import { Outlet } from 'react-router-dom'

export const InventoryControlRoot = () => {
    return <Outlet />
}
